import { render, staticRenderFns } from "./TeamMembersPage.vue?vue&type=template&id=2492026c&scoped=true&"
import script from "./TeamMembersPage.vue?vue&type=script&lang=js&"
export * from "./TeamMembersPage.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembersPage.vue?vue&type=style&index=0&id=2492026c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492026c",
  null
  
)

export default component.exports